module.exports = __webpack_public_path__ + "static/surselva-4c43d44c324f34b49b3451aa369971a4.png";